import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-free-trail',
  templateUrl: './free-trail.component.html',
  styleUrls: ['./free-trail.component.scss']
})
export class FreeTrailComponent {
  @Input() checked: boolean = false;
  @Input() trialDays: number = 30;
  @Input() disabled: boolean = true;
  @Input() message: string = 'Get 30 days free before payment start. You can cancel any time.';

  @Output() onCheck = new EventEmitter<boolean>();

  onChange() {
    if(this.disabled) return;
    this.checked = !this.checked;
    this.onCheck.emit(this.checked);
  }

}
